module.exports = __webpack_public_path__ + "static/media/peer_image5.d3f555a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/peer_image5.png
// module id = 2652
// module chunks = 0